import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import './assets/main.css'
import App from './App.vue'
//import HomeComponent from './components/HomeComponent.vue'
import SessionDetailComponentFebruary4 from './components/SessionDetailComponent/SessionDetailComponentFebruary4.vue'
import SessionDetailComponentMarch24 from './components/SessionDetailComponent/SessionDetailComponentMarch24.vue'
import SessionDetailComponentMarch24English from './components/SessionDetailComponent/SessionDetailComponentMarch24English.vue'
import SessionDetailComponentJanuary13 from './components/SessionDetailComponent/SessionDetailComponentJanuary13.vue'
import CommercialDisclosureComponent from './components/CommercialDisclosureComponent.vue'
import CheckInComponent from './components/CheckInComponent.vue'
import EnterPasswordComponent from './components/EnterPasswordComponent.vue'
import SummaryComponent from './components/SummaryComponent.vue'
import SignUpComponent from './components/SignUpComponent.vue'
import ForgotPasswordComponent from './components/ForgotPasswordComponent.vue'
import EventScheduleComponent from './components/EventSchedule.vue'
import YourAccount from './components/YourAccount.vue'
import PrePurchase from './components/PrePurchaseComponent.vue'
import PostPurchase from './components/PostPurchaseComponent.vue'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import WaiverComponent from './components/WaiverComponent.vue'
import LogInComponent from './components/LogInComponent.vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDoPamUcYQ3hewa6hrxUvIPBDrzqo0BkZ8",
  authDomain: "elevate-website-152a1.firebaseapp.com",
  projectId: "elevate-website-152a1",
  storageBucket: "elevate-website-152a1.appspot.com",
  messagingSenderId: "172409078980",
  appId: "1:172409078980:web:be2a8b5bbb78a9c5bef591",
  measurementId: "G-QP8YEPEJ1H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

export const db = getFirestore(app);

const routes = [
    { 
        path: '/', name: "Home", component: EventScheduleComponent,
    },
    {
        path: '/session-detail-february-4', name: "SessionDetailFebruary4", component: SessionDetailComponentFebruary4
    },
    {
        path: '/session-detail-march-24', name: "SessionDetailMarch24", component: SessionDetailComponentMarch24
    },
    {
        path: '/session-detail-march-24-english', name: "SessionDetailMarch24English", component: SessionDetailComponentMarch24English
    },
    {
        path: '/session-detail-january-13', name: "SessionDetailJanuary13", component: SessionDetailComponentJanuary13
    },
    {
        path: '/commercial-disclosure', name: "CommercialDisclosure", component: CommercialDisclosureComponent
    }, 
    {
        path: '/check-in', name: "CheckIn", component: CheckInComponent
    },
    {
        path: '/enter-password', name: "EnterPassword", component: EnterPasswordComponent
    },
    {
        path: '/waiver-and-photos', name: "WaiverComponent", component: WaiverComponent
    },
    {
        path: '/summary', name: "SummaryComponent", component: SummaryComponent
    },
    {
        path: '/log-in', name: "LogInComponent", component: LogInComponent
    },
    {
        path: '/sign-up', name: "SignUpComponent", component: SignUpComponent
    },
    {
        path: '/reset-password', name: "ForgotPasswordComponent", component: ForgotPasswordComponent
    },
    {
        path: '/event-schedule', name: "EventScheduleComponent", component: EventScheduleComponent
    },
    {
        path: '/account', name: "YourAccount", component: YourAccount
    },
    {
        path: '/pre-purchase', name: "PrePurchase", component: PrePurchase
    },
    {
        path: '/post-purchase', name: "PostPurchase", component: PostPurchase
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    NProgress.start();
    next();
});

router.afterEach(() => {
    NProgress.done();
});

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
createApp(App).use(pinia).use(router).mount('#app')